/* generated by tpl.py, DO NOT edit */
/* jshint -W004 */
/* jshint -W053 */
/* global exports */
/* exported tpl__readmore */
function tpl__readmore() {
    return '<div class="mi-detail__read-more mi-detail__reset"><div class="mi-detail__read-more-cover mi-detail__reset"></div><div class="mi-detail__read-more-icon-content"><span class="mi-detail__read-more-icon"></span></div><div class="mi-detail__read-more-item mi-detail__reset"><div class="mi-detail__read-more-btn mi-detail__reset">展开阅读全文</div></div></div>';
}

exports.tpl__readmore = tpl__readmore;
